"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_boost_1 = require("apollo-boost");
var GET_TOURNAMENT_RATINGS = (0, apollo_boost_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetTournamentRatings($uuids: [String]!) {\n    getTournamentRatings(uuids: $uuids)\n  }\n"], ["\n  query GetTournamentRatings($uuids: [String]!) {\n    getTournamentRatings(uuids: $uuids)\n  }\n"])));
exports.default = GET_TOURNAMENT_RATINGS;
var templateObject_1;
